import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

// Routes
import routes from './config/routes/routes';

// Style
import './App.css';

// Admin

import Admin from './pages/admin/Admin';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Redirects and static routes */}
        <Route path="/login" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/*" element={<Admin />} />

        {/* Dynamic routes from routes */}
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={<route.layout />}>
            <Route path={route.path} element={<route.component path={route.path} title={route.title} breadTitle={route.breadTitle} />} />
          </Route>
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
